<template>
  <section>
    <div>
      <table>
        <tr>
          <td v-if="isPOLineObj">
            <dt>Status</dt>
            <dd v-if="!onEditStatus"> {{ detailObj.statusName || '&nbsp;' }}
              <!-- {{ detailObj.statusName || '&nbsp;' }} -->
              <i v-if="!isPOLineObj && !onEditStatus" style="opacity: 50%" class="ml-1 fa fa-pencil" @click="onClickEditStatus"></i>
            </dd>
            <!-- <dd v-else>
              <div class="d-flex justify-content-start align-items-end">
                <b-form-select v-model="lineStatusUpdate" @input="onChangeStatus">
                  <option v-for="status in statuses" :key="status.id" :value="status.id">{{ status.name }}</option>
                </b-form-select>
                <b-button size="sm" @click="onEditStatus = false" variant="danger"><i class="fa fa-close"></i></b-button>
              </div>
            </dd> -->
          </td>
          <td v-if="isPOLineObj">
            <dt>Sales Order</dt>
            <dd>
              <a class="selector-link" @click="onRouteSalesOrder">
                {{ detailObj.salesOrderId }}
              </a>
            </dd>
          </td>
          <td>
            <dt>Part Number</dt>
            <dd>{{ detailObj.partNumber || '&nbsp;' }}</dd>
          </td>
          <td style="width: 100px;">
            <dt>Description</dt>
            <dd style="word-wrap: break-word !important; overflow-wrap: break-word;">{{ detailObj.description || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>Manufacturer</dt>
            <dd>{{ detailObj.mfgName || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>Date Code</dt>
            <dd>{{ detailObj.dateCode || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>COO</dt>
            <dd>{{ detailObj.countryOfOriginName || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>RoHS</dt>
            <dd>{{ detailObj.leadFree || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>Lot</dt>
            <dd>{{ detailObj.lotCode || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>Revisions</dt>
            <dd>{{ detailObj.revision || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>Packaging</dt>
            <dd>{{ detailObj.package || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>SPQ</dt>
            <dd>{{ detailObj.piecePerPkg || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>Vendor</dt>
            <dd>{{ detailObj.companyName || '&nbsp;' }}</dd>
          </td>
          <td v-if="!isPOLineObj">
            <dt>Qty Ordered</dt>
            <dd>{{ detailObj.poLineQuantity || '&nbsp;' }}</dd>
          </td>
          <td>
            <dt>{{ isPOLineObj ? 'Ordered' : 'Qty To Test' }}</dt>
            <dd v-if="!onEditQuantity"> 
              {{ detailObj.quantity }}  
              <i v-if="!isPOLineObj" style="opacity: 50%" class="ml-1 fa fa-pencil" @click="onEdit"></i>
            </dd>
            <div class="d-flex justify-content-start align-items-end" v-else>
              <b-form-input type="number" v-model="newQty"  style="width: 50%" />
              <b-button size="sm" @click="onSaveQty" :disabled="isSaving" variant="success"><i :class="`fa ${ isSaving ? 'fa-spinner fa-pulse fa-fw' : 'fa-check'}`"></i></b-button>
               <b-button size="sm" @click="onEditQuantity = false" variant="danger"><i class="fa fa-close"></i></b-button>
            </div>
          </td>
          <td v-if="!isPOLineObj">
            <dt>{{ 'Total Sent Items' }}</dt>
            <dd>{{ totalSentItems }}</dd>
          </td>
        </tr>
      </table>
      <table>
        <tr v-if="!isPOLineObj">
          <td>
            <dt>Instructions</dt>
            <dd v-if="!onEditInstruction"> 
              {{ detailObj.comments ? detailObj.comments : '-' }}  
              <i style="opacity: 50%" class="ml-1 fa fa-pencil" @click="onClickEditInstructions"></i>
            </dd>
            <div class="d-flex justify-content-start align-items-end" v-else>
              <b-textarea v-model="instruction" rows="2"/>
              <b-button size="sm" @click="onSaveInstruction" :disabled="isSavingInst" variant="success"><i :class="`fa ${ isSavingInst ? 'fa-spinner fa-pulse fa-fw' : 'fa-check'}`"></i></b-button>
              <b-button size="sm" @click="onEditInstruction = false" variant="danger"><i class="fa fa-close"></i></b-button>
            </div>
          </td>
          <td></td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { date } from '@/shared/filters';

export default {
  props: {
    detailObj: {
      type: Object,
      default: null
    },
    isPOLineObj: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date,
      onEditQuantity: false,
      onEditStatus: false,
      onEditInstruction: false,
      lineStatusUpdate: 0,
      newQty: 0,
      instruction: null,
      isSaving: false,
      isSavingInst: false,
      statuses: [
        {id: 1488, name: 'Passed'},
        {id: 1489, name: 'Failed'},
      ]
    }
  },
  computed: {
    ...mapGetters('pickTicket', ['pickTicketLinesByServiceOrderLine' ]),
    totalSentItems() {
      return this.pickTicketLinesByServiceOrderLine.length > 0 ? this.pickTicketLinesByServiceOrderLine.map(x => x.quantityPulled).reduce((a, b) => a + b) : 0;
    }
  },
  methods: {
    ...mapActions('serviceOrderLines', ['getByServiceOrderId', 'updateServiceOrderLine' ]),
    formatMoney(val, currency) {
      try {
        var str = Number(val).toFixed(2).toString().split('.');
        if (str[0].length >= 3) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1]) {
          if (str[1].length < 2) {
            while (str[1].length < 2) { str[1] = str[1] + "0"; }
          } else if (str[1].length > 2) {
            str[1] = str[1].substring(0, 2)
          }
        }
        return currency + str.join('.');
      } catch {
        return val;
      }
    },
    async onSaveQty() {
      if (this.newQty == '') {
          return;
        } else {
          try {
            this.isSaving = true;
            const result = await this.updateServiceOrderLine({...this.detailObj, quantity: this.newQty}).catch(() => {
              this.isSaving = false;
            });
            if (result) {
              await this.getByServiceOrderId(result.serviceOrderId).then(() => {
                this.detailObj.quantity = this.newQty;
                this.newQty = 0;
                this.onEditQuantity = false;
              });
            }

            this.isSaving = false;
          }catch (e) {
            this.isSaving = false;
          }
        }
    },
    onEdit() {
      this.onEditQuantity = true;
      this.newQty = this.detailObj.quantity
    },
    onClickEditStatus() {
      this.onEditStatus = true
      this.lineStatusUpdate = this.detailObj.statusId;
    },
    onClickEditInstructions() {
      this.onEditInstruction = true
      this.instruction = this.detailObj.comments;
    },
    async onChangeStatus() {
      if (this.detailObj.statusId != this.lineStatusUpdate) {
        let stat = this.statuses.find(x => x.id == this.lineStatusUpdate);
        const confirmation = await this.openConfirmBox({
          message: `Are you sure you want to override the status to ${stat.name}?`,
          footerClass: 'p-2',
          hideHeaderClose: false,
        });
        this.onEditStatus= false;
        if (confirmation) {
          const result = await this.updateServiceOrderLine({...this.detailObj, statusId: this.lineStatusUpdate});
          if (result) {
            await this.getByServiceOrderId(result.serviceOrderId);
          }
        }
      }
    },
    async onSaveInstruction() {
      if (this.instruction != this.detailObj.comments) {
        this.isSavingInst = true;
        const result = await this.updateServiceOrderLine({ ...this.detailObj, comments: this.instruction });
        if (result) {
          await this.getByServiceOrderId(result.serviceOrderId).then(() => {
            this.detailObj.comments = this.instruction;
            this.instruction = null;
          });
        }
        this.isSavingInst = false;
        
        this.onEditInstruction = false;
      }
    },
    onRouteSalesOrder() {
      this.$router.push({ name: 'salesorders.edit',params: { id: this.detailObj.salesOrderId }})
    }
  }
}
</script>

<style scoped>
.selector-link {
  color: #20a8d8 !important;
  font-size: 100%;
  font-weight: 700;
  padding-bottom: 1px;
}
.selector-link:hover {
  color: #167495 !important;
  text-decoration: underline !important;
  cursor: pointer;
}
table {
  width: 100%;
  cursor: context-menu;
}
td {
  padding-left: 10px;
  white-space: nowrap;
}
</style>